export const getters = {
  menuFilterList: ({ menuFilterList }) => menuFilterList,
  restrictionIntervalList: ({ restrictionIntervalList }) => restrictionIntervalList,
  menuGuidFilter: ({ menuGuidFilter }) => menuGuidFilter,
  sectionGuidFilter: ({ sectionGuidFilter }) => sectionGuidFilter,
  saleRateFilter: ({ saleRateFilter }) => saleRateFilter,
  dateRangeFilter: ({ dateRangeFilter }) => dateRangeFilter,
  undo: ({ undoBuffer }) => undoBuffer[0] || null
};
